module.exports = __webpack_public_path__ + "img/ic_plus_white.a214406d.svg";